import React, {useState} from 'react';

import {endOfDay, startOfDay} from 'date-fns';
import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {DateRange} from 'components/ui-kit/DateRange';
import {PillVariant} from 'components/ui-kit/Pills';
import {dashboardState$, dateRangeChanged, dateTypeChanged} from 'models/dashboard';
import {DashboardDateType} from 'types';
import {dashboardPeriod} from 'utils/dashboardPeriod';

import {Root, StyledPill} from './styled';

export const Dates: React.FC = () => {
    const {t} = useTranslation();
    const {dateRange, dateType} = useStore(dashboardState$);
    const [periodRange, setPeriodRange] = useState<[Date | null, Date | null]>([
        dateRange.start,
        dateRange.end,
    ]);
    const apply = (start: Date, end: Date, type: DashboardDateType) => {
        dateRangeChanged({start, end});
        dateTypeChanged(type);
    };
    return (
        <Root>
            {[
                DashboardDateType.Day,
                DashboardDateType.Week,
                DashboardDateType.Month,
                DashboardDateType.Quarter,
                DashboardDateType.Year,
            ].map((type) => (
                <StyledPill
                    key={type}
                    isActive={dateType === type}
                    variant={PillVariant.text}
                    onClick={() => {
                        const {start, end} = dashboardPeriod(type);
                        apply(start, end, type);
                    }}
                >
                    {t('pages.dashboard.dates.' + type.toLowerCase())}
                </StyledPill>
            ))}
            <StyledPill
                isActive={dateType === DashboardDateType.Period}
                variant={PillVariant.text}
                onClick={() => {
                    const [start, end] = periodRange;
                    if (start && end)
                        apply(startOfDay(start), endOfDay(end), DashboardDateType.Period);
                }}
            >
                {t('pages.dashboard.dates.period')}
            </StyledPill>
            <DateRange
                value={periodRange}
                onChange={(pair) => {
                    if (!pair) return;
                    setPeriodRange(pair);
                    const [start, end] = pair;
                    if (start && end && start <= end)
                        apply(startOfDay(start), endOfDay(end), DashboardDateType.Period);
                }}
            />
        </Root>
    );
};
